import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ActivateEmergencyCard from './ActivateEmergencyCard';
import Layout from '@/components/Layout/Layout';
import { setNavigationSource } from '@/utils/navigationSource';
import { getMemberInfo } from '@/hooks/useMembers';

const ActivateEmergencyCardWrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const memberInfo = getMemberInfo();

  // Set navigation source when page loads so modules navigate back here
  useEffect(() => {
    setNavigationSource('overview', window.location.pathname);
  }, []);

  const handleBack = () => {
    // Check if there's a backUrl in the navigation state
    const backUrl = (location.state as any)?.backUrl;
    
    if (backUrl) {
      // Use the provided backUrl (e.g., '/dashboard' from Insights)
      navigate(backUrl);
    } else {
      // Fallback: Get memberId from location.state or use current member
      const memberId = (location.state as any)?.memberId || memberInfo.id;
      // Navigate back to MemberDetail as default behavior
      navigate(`/profile/family/member/${memberId}`);
    }
  };

  return (
    <Layout hideExit showGradient hideProfilePicker hideFooterNav onBack={handleBack}>
      <ActivateEmergencyCard />
    </Layout>
  );
};

export default ActivateEmergencyCardWrapper;
